export default __webpack_public_path__ + "static/media/tuna.6b130a5d.jpg";